export const DEFAULT_DESTINATION_DELIVERY_TIMEOUT_SECONDS = 60;
export const MAX_DESTINATION_DELIVERY_TIMEOUT_SECONDS = 15 * 60;

type DestinationDeliveryTimeoutConfig = {
  delivery_timeout?: number | null;
};

type LegacySubscriptionAttemptTimeoutConfig = {
  attempt_timeout?: number | null;
};

/**
 * `delivery_timeout` is the canonical destination setting. `subscription.attempt_timeout` is a
 * temporary compatibility fallback for organizations whose legacy value has not been backfilled
 * onto destinations yet; remove that fallback after the rollout is complete.
 */
export const getDestinationDeliveryTimeoutSeconds = (
  destination: DestinationDeliveryTimeoutConfig,
  subscription?: LegacySubscriptionAttemptTimeoutConfig
): number =>
  destination.delivery_timeout ??
  subscription?.attempt_timeout ??
  DEFAULT_DESTINATION_DELIVERY_TIMEOUT_SECONDS;

export const hasLongDestinationDeliveryTimeout = (
  destination: DestinationDeliveryTimeoutConfig,
  subscription?: LegacySubscriptionAttemptTimeoutConfig
): boolean =>
  getDestinationDeliveryTimeoutSeconds(destination, subscription) >
  DEFAULT_DESTINATION_DELIVERY_TIMEOUT_SECONDS;
